import {
  DependencyError,
  parseFormData,
  PutOrPostPersonBodyCore
} from '@cumu/shared';
import { controller } from '@github/catalyst';
import { allFormData } from '../forms/utilities';
import { validateForm } from '../forms/validation';

@controller('person-matches')
export class PersonMatchesElement extends HTMLElement {
  disconnectController: AbortController | undefined;
  refreshTimeout = 0;
  lastFingerprint: string | undefined;

  get form() {
    return this.closest('form');
  }

  connectedCallback() {
    const form = this.form;
    if (!form) {
      return;
    }

    this.lastFingerprint = getFingerprint(allFormData(form));

    this.disconnectController?.abort();
    this.disconnectController = new AbortController();

    form.addEventListener('change', this.scheduleRefresh, {
      signal: this.disconnectController.signal
    });

    form.addEventListener('editable-list-change', this.scheduleRefresh, {
      signal: this.disconnectController.signal
    });
  }

  disconnectedCallback() {
    this.disconnectController?.abort();
  }

  refresh = async () => {
    const body = allFormData(this.form!);
    const currentFingerprint = getFingerprint(body);
    if (this.lastFingerprint === currentFingerprint) {
      return;
    }
    const result = await validateForm(this.form!, false);
    if (!result.valid) {
      return;
    }
    this.lastFingerprint = currentFingerprint;
    const url = new URL(this.getAttribute('src')!, location.origin);
    const response = await fetch(url, {
      method: 'POST',
      body
    });
    if (!response.ok) {
      throw new DependencyError(response, await response.text());
    }
    const html = await response.text();
    const template = document.createElement('template');
    template.innerHTML = html;
    this.replaceWith(template.content);
  };

  scheduleRefresh = () => {
    clearTimeout(this.refreshTimeout);
    this.refreshTimeout = setTimeout(this.refresh, 300);
  };
}

function getFingerprint(formData: FormData) {
  const {
    first_name,
    last_name,
    dob,
    ssn,
    medicaid_id,
    veteran_id,
    agingis_id,
    scsep_participant_id,
    external_id,
    emails,
    phones
  } = parseFormData<PutOrPostPersonBodyCore>(formData);
  return [
    first_name,
    last_name,
    dob,
    ssn,
    medicaid_id,
    veteran_id,
    agingis_id,
    scsep_participant_id,
    external_id,
    ...emails.map(e => e.email),
    ...phones.map(p => p.number)
  ].join('/');
}
